import { render, staticRenderFns } from "./AccettazioneAbruzzoView.vue?vue&type=template&id=34f5fe45"
import script from "./AccettazioneAbruzzoView.vue?vue&type=script&lang=js"
export * from "./AccettazioneAbruzzoView.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneAbruzzoView.vue?vue&type=style&index=0&id=34f5fe45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports